export default __webpack_public_path__ + "static/media/ui_ux_design.85434722.svg";